import { buildTemplateAoa, triggerTemplateDownload } from "./buildTemplateWorkbook";
import type { BulkMeterTemplateRow } from "./buildTemplateWorkbook";
import { getTemplateColumns } from "./templateColumns";
import { getBulkMeterTemplateRows } from "@services/bulkMeterUpload";

type DownloadTemplateDeps = {
  level1ResourceId: string;
  isSeqwater: boolean;
  fileName: string;
  t: (key: string) => string;
  // Injected for testability; default to the real implementations.
  fetchRows?: (level1ResourceId: string) => Promise<BulkMeterTemplateRow[]>;
  download?: (aoa: (string | number)[][], fileName: string) => void;
};

// Fetch the scheme's offtakes, build the pre-populated workbook, and trigger the download.
// Returns "empty" when the scheme has no qualifying offtakes (a headers-only template is
// still downloaded). Throws on fetch failure — the caller surfaces the error toast.
export const downloadTemplate = async ({
  level1ResourceId,
  isSeqwater,
  fileName,
  t,
  fetchRows = getBulkMeterTemplateRows,
  download = triggerTemplateDownload,
}: DownloadTemplateDeps): Promise<"downloaded" | "empty"> => {
  const rows = await fetchRows(level1ResourceId);
  const headerLabels = getTemplateColumns(isSeqwater).map(col => t(col.i18nKey));
  const aoa = buildTemplateAoa(rows, { isSeqwater, headerLabels });
  download(aoa, fileName);
  return rows.length === 0 ? "empty" : "downloaded";
};
